export const FIREBASE_PERMISSION_COUNT_KEY = 'firebase-permission-count'